import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationLicensesGet = {
    path: "/licenses",
    method: ERouteHttpVerb.GET
};
export { routeLocationLicensesGet };
